import React, { useEffect,useState } from 'react';
import _sortBy from 'lodash/sortBy';
import PropTypes from 'prop-types';

import { importStatic } from 'utils';

const propTypes = {
  heads: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      value: PropTypes.string,
    })
  ).isRequired,
  tableData: PropTypes.arrayOf(PropTypes.object).isRequired,
  defaultSortedColumn: PropTypes.string,
  formatter: PropTypes.func,
  tableTitle: PropTypes.any,
};

const defaultProps = {
  heads: [],
  tableData: [],
  defaultSortedColumn: '',
  formatter: (value) => value,
};

const ChartTable = ({ heads, formatter, tableData, defaultSortedField, tableTitle }) => {
  const [chartTableData, setChartTableData] = useState(
    sortData(tableData, 'asc', defaultSortedField)
  );
  const [sortedColumn, setSortedColumn] = useState(defaultSortedField);
  const [sort, setSort] = useState('asc');
  const [showCaret, setShowCaret] = useState(false);

  useEffect(() => {
    setChartTableData(sortData(tableData, 'asc', defaultSortedField));
  }, [tableData]);

  useEffect(() => {
    setShowCaret(true);
  }, []);

  function sortData(arr, sortDirection, columnName) {
    if (sortDirection === 'asc') {
      return _sortBy(arr, [columnName]);
    } else {
      return _sortBy(arr, [columnName]).reverse();
    }
  }

  const sortColumn = (columnName) => {
    setSortedColumn(columnName);
    const sortedTableData = sortData(chartTableData, sort === 'asc' ? 'desc' : 'asc', columnName);
    if (sort === 'asc') {
      setSort('desc');
      setChartTableData(sortedTableData);
    } else {
      setSort('asc');
      setChartTableData(sortedTableData);
    }
  };

  const renderCaret = (columnName) => {
    if (sortedColumn === columnName) {
      if (sort === 'desc') {
        return (
          <img
            src={importStatic('/ui-router/images/bottom_sort_unselected.png')}
            alt="desc"
            width="8"
            height="5"
          />
        );
      } else {
        return (
          <img
            src={importStatic('/ui-router/images/top_sort_unselected.png')}
            alt="asc"
            width="8"
            height="5"
          />
        );
      }
    }
    return (
      <>
        <img
          src={importStatic('/ui-router/images/top_sort_unselected.png')}
          alt="asc"
          width="8"
          height="5"
        />
        <img
          src={importStatic('/ui-router/images/bottom_sort_unselected.png')}
          alt="desc"
          width="8"
          height="5"
        />
      </>
    );
  };

  return (
    <div className="overflow-x-auto w-100">
      {tableTitle}
      <table className="mt-4 demographics-chart-table w-100">
        <thead>
          <tr>
            {heads.map(({ title, value }, idx) => (
              <th
                key={idx}
                className={`LightTextStyle ${idx === 0 ? 'px-2 pr-md-3' : 'px-3 px-md-5'}${
                  value === sortedColumn ? ' selected' : ''
                }`}
                onClick={() => sortColumn(value)}
              >
                {title}
                {showCaret && <a className="sortyby ml-1">{renderCaret(value)}</a>}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {chartTableData.map((row, idx) => (
            <tr
              key={idx}
              className={`${row.className ? row.className : row.selected ? 'selected' : ''}`}
            >
              {heads.map(({ title, value }, idx2) => (
                <td
                  key={title + idx2}
                  className={`openSansBlack ${idx2 === 0 ? 'p-2' : 'px-3 px-md-5'}${
                    sortedColumn === value ? ' selected' : ''
                  }`}
                >
                  {idx2 === 0 ? row[value] : formatter(row[value])}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

ChartTable.propTypes = propTypes;
ChartTable.defaultProps = defaultProps;

export default ChartTable;
